import MessageSent from './MessageSent.jsx';

export default MessageSent;